"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var MINUTE = 60;
var DURATION = {
  STANDARD: 'STANDARD',
  LONGFORM_SHORT: 'LONGFORM_SHORT',
  LONGFORM_MEDIUM: 'LONGFORM_MEDIUM',
  LONGFORM_LONG: 'LONGFORM_LONG'
};

var getDefaultDuration = function getDefaultDuration(clips) {
  var totalDuration = clips.reduce(function (total, _ref) {
    var duration = _ref.duration;
    return total + !Number.isNaN(duration) ? duration : 0;
  }, 0);

  if (totalDuration > 20 * MINUTE) {
    return DURATION.LONGFORM_LONG;
  }

  if (totalDuration > 10 * MINUTE) {
    return DURATION.LONGFORM_MEDIUM;
  }

  if (totalDuration > 5 * MINUTE) {
    return DURATION.LONGFORM_SHORT;
  }

  return DURATION.STANDARD;
};

var _default = getDefaultDuration;
exports.default = _default;